"use client";

import { createTheme } from "@mui/material";

const theme = createTheme({
    typography: {
        fontFamily: "Poppins, sans-serif",
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '30px',
                    fontWeight: 700,
                    fontSize: '12px',
                    minWidth: '105px',
                    height: '28px',
                    boxShadow: 'none',
                    letterSpacing: '1.44px',
                    lineHeight: '150%',
                    '&:hover' : {
                        boxShadow: 'none'
                    }
                },
            },
            variants: [
                {
                    props: { variant: 'contained' },
                    style: {
                        backgroundColor: 'var(--Neutrals-Main-Neutral---Limed-Spruce)',
                        '&:hover': {
                            backgroundColor: 'var(--Neutrals-Main-Neutral---Limed-Spruce)',
                        },

                    },
                },

                {
                    props: { variant: 'outlined' },
                    style: {
                        border:'2px solid var(--Neutrals-Main-Neutral---Limed-Spruce)',
                        color: 'var(--Neutrals-Main-Neutral---Limed-Spruce)', 
                        '&:hover': {
                            border:'2px solid var(--Neutrals-Main-Neutral---Limed-Spruce)',
                            color: 'var(--Neutrals-Main-Neutral---Limed-Spruce)',
                        },
                    },
                },
            ],
        },
    }
});

export default theme;